import React from "react";

import Agri from "@/assets/images/webp/industryAgriculture.webp";
import Pharma from "@/assets/images/webp/industryPharma.webp";
import Automobile from "@/assets/images/webp/industryAutomobile.webp";
import FMCG from "@/assets/images/webp/industryFMCG.webp";
import Textiles from "@/assets/images/webp/industryTextile.webp";
import Electronics from "@/assets/images/webp/industryElectronics.webp";
import Food from "@/assets/images/webp/industryFoods.webp";
import Building from "@/assets/images/webp/industryBuildingMaterial.webp";
import Cosmetics from "@/assets/images/webp/industryCosmatic.webp";
import Ceramic from "@/assets/images/webp/industryCeramic.webp";
import OilBarrel from "@/assets/images/webp/industryOil.webp";

import { motion } from "framer-motion";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { Link } from "react-router-dom";

const Industries = React.memo(() => {
  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  return (
    <section className={`industries-section`}>
      <div className={`head-text center container medium`}>
        <motion.h2 className={`head center animate-child`}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          custom={0.2}
          variants={fadeUpVariant}
        >Industries we Serve</motion.h2>
        <motion.p
          className="animate-child"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          custom={0.2}
          variants={fadeUpVariant}>Connecting businesses across diverse industries worldwide, helping them grow, trade and succeed.</motion.p>
      </div>
      <div className="container">
        <div className={`row`}>
          <div className={`col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12`} >
            <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=agriculture`} target="_blank" href={`${publicRoutePaths.MARKET_DETAIL.path}/?category=agriculture`} title="agriculture">
              <motion.div
                className="service animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}>
                <span className="icon">
                  <img src={Agri} alt="Agriculture import export network" loading="lazy" width={90} height={90} />
                </span>
                <span>Agriculture</span>
              </motion.div>
            </Link>

          </div>

          <div className={`col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12`}>
            <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=textiles`} target="_blank" href={`${publicRoutePaths.MARKET_DETAIL.path}/?category=textiles`} title="Textiles" >
              <motion.div
                className="service animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >
                <span className="icon">
                  <img src={Textiles} alt="Textiles import export network" loading="lazy" width={90} height={90} />
                </span>
                <span>Textiles</span>
              </motion.div>
            </Link>

          </div>

          <div className={`col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12 `}>
            <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=pharmaceuticals`} target="_blank" href={`${publicRoutePaths.MARKET_DETAIL.path}/?category=pharmaceuticals`} title="Pharmaceuticals" >
              <motion.div
                className="service animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >
                <span className="icon">
                  <img src={Pharma} alt="Pharmaceuticals import export network" loading="lazy" width={90} height={90} />
                </span>
                <span>Pharmaceuticals</span>
              </motion.div>
            </Link>

          </div>

          <div className={`col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12`}>
            <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=building-materials`} target="_blank" href={`${publicRoutePaths.MARKET_DETAIL.path}/?category=building-materials`} title="Building Materials" >
              <motion.div
                className="service animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}>
                <span className="icon">
                  <img src={Building} alt="Building Materials import export network" loading="lazy" width={90} height={90} />
                </span>
                <span>Building Materials</span>
              </motion.div>
            </Link>

          </div>

          <div className={`col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12`}>
            <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=electronics-and-gadgets`} target="_blank" href={`${publicRoutePaths.MARKET_DETAIL.path}/?category=electronics-and-gadgets`} title="Electronics & Gadgets">
              <motion.div
                className="service animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >
                <span className="icon">
                  <img src={Electronics} alt="Electronics & Gadgets import export network" loading="lazy" width={90} height={90} />
                </span>
                <span>Electronics & Gadgets</span>
              </motion.div>
            </Link>

          </div>

          <div className={`col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12`}>
            <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=ceramic`} target="_blank" href={`${publicRoutePaths.MARKET_DETAIL.path}/?category=ceramic`} title="Ceramic">
              <motion.div
                className="service animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >
                <span className="icon">
                  <img src={Ceramic} alt="Ceramic import export network" loading="lazy" width={90} height={90} />
                </span>
                <span>Ceramic</span>
              </motion.div>
            </Link>
          </div>

          <div className={`col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12`}>
            <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=food-products`} target="_blank" href={`${publicRoutePaths.MARKET_DETAIL.path}/?category=food-products`} title="Food Products">
              <motion.div
                className="service animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >
                <span className="icon">
                  <img src={Food} alt="Food Products import export network" loading="lazy" width={90} height={90} />
                </span>
                <span>Food Products</span>
              </motion.div>
            </Link>

          </div>

          <div className={`col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12`}>
            <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=oil-gas`} target="_blank" href={`${publicRoutePaths.MARKET_DETAIL.path}/?category=oil-gas`} title="Oil & Gas">
              <motion.div
                className="service animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >
                <span className="icon">
                  <img src={OilBarrel} alt="Oil-gas import export network" width={90} height={90} />
                </span>
                <span>Oil & Gas</span>
              </motion.div>
            </Link>

          </div>

          <div className={`col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12`}>
            <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=cosmetics-and-personal-care`} target="_blank" href={`${publicRoutePaths.MARKET_DETAIL.path}/?category=cosmetics-and-personal-care`} title="Cosmetics & Personal Care">
              <motion.div
                className="service animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >
                <span className="icon">
                  <img src={Cosmetics} alt="Cosmetics & Personal Care import export network" loading="lazy" width={90} height={90} />
                </span>
                <span>Cosmetics & Personal Care</span>
              </motion.div>
            </Link>

          </div>

          <div className={`col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12`}>
            <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=automobile-and-auto-parts`} target="_blank" href={`${publicRoutePaths.MARKET_DETAIL.path}/?category=automobile-and-auto-parts`} title="Automobile & Auto Parts">
              <motion.div
                className="service animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >
                <span className="icon">
                  <img src={Automobile} alt="Automobile & Auto Parts import export network" loading="lazy" width={90} height={90} />
                </span>
                <span>Automobile & Auto Parts</span>
              </motion.div>
            </Link>

          </div>

          <div className={`col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12`}>
            <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=fmcg`} target="_blank" href={`${publicRoutePaths.MARKET_DETAIL.path}/?category=fmcg`} title="FMCG">
              <motion.div
                className="service animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >
                <span className="icon">
                  <img src={FMCG} alt="FMCG import export network" loading="lazy" width={90} height={90} />
                </span>
                <span>FMCG</span>
              </motion.div>
            </Link>

          </div>
          <div className={`col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12`}>
            <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=all`} target="_blank" href={`${publicRoutePaths.MARKET_DETAIL.path}/?category=all`} title="Explore More">
              <motion.div
                className="service animate-child explore-btn"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >
                <span className="icon">
                  <i className="sprite explore"></i>
                </span>
                <span>Explore More</span>
              </motion.div>
            </Link>

          </div>
        </div>
      </div>
    </section>
  );
})

export default Industries;
